import styled, { css } from 'styled-components';
import { smallScreenListWidth, listWidth, collapsedListWidth } from '../list/styled';
import { Box, Text } from '@bechtel/gds';
interface ReportDetailContainerStyledProps {
  isListCollapsed?: boolean;
}

export const ReportDetailContainerStyled = styled.div<ReportDetailContainerStyledProps>`
  transition-duration: 160ms;
  transition-timing-function: ease-in;
  transition-property: left;
  height: 100vh;
  position: absolute;
  left: ${listWidth};
  width: calc(100% - ${listWidth});
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
    width: calc(100% - ${smallScreenListWidth});
  }
  ${({ isListCollapsed }) =>
    isListCollapsed &&
    css`
      left: ${collapsedListWidth} !important;
      width: calc(100% - ${collapsedListWidth}) !important;
      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
    `}
`;
export const ReportHeaderRowStyled = styled(Box).attrs({
  py: { sm: '700' },
  pl: { sm: '600' },
  mb: { sm: '700' },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export const ReportContainerStyled = styled.div`
  position: absolute;
  overflow-y: auto;
  height: 100%;
  background-color: white;
  width: 100%;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: 100%;
  }
`;
